import React, {useEffect} from 'react'
import "../styles/seopage.css"

export default function SportBetStatPage() {
    //TITLE, META TAG BEÁLLITÁS
    useEffect(() => {
        document.title = "Sportfogadás statisztikák – Adatalapú döntések | FociFanatik";

        const meta = document.querySelector("meta[name='description']");
        if (meta) {
            meta.setAttribute(
                "description",
                "Mi az a sportfogadás statisztika, trendek és elemzések. Segítünk könnyebben dönteni."
            );
        }
    }, []);

    return (
        <div className="seo-page">

            {/* HERO */}
            <section className="seo-hero">
                <h1>Tippmix statisztika vezetése egyszerűen</h1>
                <p>
                    A sikeres sportfogadás nem szerencse kérdése.
                    A sportfogadási statisztika vezetése segít felismerni,
                    mely tippek nyereségesek hosszú távon – és melyek nem.
                </p>
                <a href="/regisztracio" className="primary-btn">
                    Kezdem a statisztika vezetését
                </a>
            </section>

            {/* CONTENT */}
            <section className="seo-content">

                <h2>Mi az a sportfogadási statisztika?</h2>
                <p>
                    A sportfogadási statisztika egy rendszer, amelyben minden egyes fogadásodat
                    rögzíted: a tétet, az oddsot, az eseményt és az eredményt.
                    Ez lehetővé teszi, hogy objektíven lásd a teljesítményedet.
                </p>

                <h2>Miért fontos a fogadási statisztika vezetése?</h2>
                <ul>
                    <li>📊 Megmutatja, valóban nyereséges vagy-e</li>
                    <li>📉 Segít kiszűrni a vesztes stratégiákat</li>
                    <li>🧠 Tudatosabb döntéseket hozol</li>
                    <li>💰 Elkerülheted a hosszú távú veszteségeket</li>
                </ul>

                <h2>Mi történik statisztika nélkül?</h2>
                <p>
                    A legtöbb sportfogadó emlékezetből ítéli meg a teljesítményét.
                    Ez torz képet ad: a vesztes tippek gyorsan feledésbe merülnek,
                    míg a nyertesek túlértékelődnek.
                </p>

                <h2>Hogyan segít a FociFanatik?</h2>
                <p>
                    A FociFanatik egy online sportfogadási statisztika vezető rendszer,
                    amely automatikusan összesíti az adataidat.
                    Nem Excel, nem jegyzetfüzet – hanem egy átlátható megoldás.
                </p>

                <ul>
                    <li>✔️ Tippjeid automatikus nyilvántartása</li>
                    <li>✔️ Nyereség / veszteség kimutatások</li>
                    <li>✔️ Hosszú távú statisztikák</li>
                    <li>✔️ Teljesen ingyenes</li>
                </ul>

                <h2>Kinek ajánlott?</h2>
                <p>
                    Kezdőknek, akik tanulni szeretnének a hibáikból,
                    és haladóknak, akik profi szintre emelnék a fogadásaikat.
                </p>

            </section>

            {/* CTA */}
            <section className="seo-cta">
                <h3>Kezdd el ma a sportfogadási statisztika vezetését</h3>
                <p>Regisztrálj ingyen, és lásd valós számok alapján a teljesítményed.</p>
                <a href="/regisztracio" className="primary-btn">
                    Ingyenes regisztráció
                </a>
            </section>

        </div>
    )
}
